module.exports = __webpack_public_path__ + "img/sewingArmyLogo.11d1473f.png";